<section class="w-full flex flex-col">
  <header class="w-full flex flex-row items-center py-4 px-6 border-b border-gray-200">
    <p class="w-full text-lg font-semibold">{{ dynamicDialogTitle }}</p>
    <ts-button
      [type]="'icon'"
      [icon]="'close'"
      [color]="'basic'"
      [matTooltip]="'Close'"
      (click)="discard()"
    ></ts-button>
  </header>

  <form [formGroup]="createTaskListTemplateForm" class="flex flex-col py-10 px-6">
    <mat-form-field>
      <mat-label>Template Name</mat-label>
      <input matInput [formControlName]="'name'" autocomplete="off" data-testid="template-name-input" />
    </mat-form-field>
    @if (hasRequiredFieldError('name')) {
      <mat-error class="text-sm">Name is required</mat-error>
    }

    <mat-form-field class="pt-10">
      <mat-label>Template Type</mat-label>
      <mat-select [formControlName]="'applicableType'" data-testid="template-type-select">
        <mat-option [value]="" data-testid="option-no-type-selected">--- No Type Selected ---</mat-option>
        @for (type of applicableTypes; track type.value) {
          <mat-option [value]="type.value" [attr.data-testid]="'option-' + type.value">
            {{ type.label }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (hasRequiredFieldError('applicableType')) {
      <mat-error class="text-sm">Type is required</mat-error>
    }
  </form>

  <footer class="flex justify-end border-t border-gray-200 pt-4 pb-4 px-6">
    <ts-button [type]="'stroked'" [color]="'basic'" (click)="discard()" data-testid="cancel-button">Cancel</ts-button>
    <ts-button
      [type]="'flat'"
      [disabled]="createTaskListTemplateForm.pristine || createTaskListTemplateForm.invalid || isLoading"
      [loading]="isLoading"
      (click)="save()"
      class="ml-3"
      data-testid="save-button"
      >Save</ts-button
    >
  </footer>
</section>
